// extracted by mini-css-extract-plugin
module.exports = {"free_shipping":"freeShipping_free_shipping__VxT0C","locations_list":"freeShipping_locations_list__FdPSz"};